__turbopack_context__.v({
  "pillContainer": "styles-module__QaKtVq__pillContainer",
  "pillList": "styles-module__QaKtVq__pillList",
  "placeholderPillsWrapper": "styles-module__QaKtVq__placeholderPillsWrapper",
  "subMenuContainer": "styles-module__QaKtVq__subMenuContainer",
  "subMenuContainer__isOpen": "styles-module__QaKtVq__subMenuContainer__isOpen",
});
